import { Aboutus } from "../components/about-us";
import { Announcements } from "../components/announcement";
import { ApplicationRequirements } from "../components/application-requirements";
import { CarouselSlider } from "../components/carousel";
import { Footer } from "../components/footer";
import { TopHeader } from "../components/top-header";
import { Header } from "../components/head";
import { ServicesAndContacts } from "../components/sercives-and-contact";
import { Unversities } from "../components/unversities";
import { ApplicationGetWays } from "../components/application-getways";
import { Helmet } from "react-helmet";
import {Testimonials} from "../components/testimonials";


function Home() {
  // alert('sorry, site is under technical modifications, services will be back as soon as possible')
  return (
    <>
      <Helmet>
        <title>HOME | AIA</title>
        <meta name="description" content="get scholarship and opportunities to study abroad in china or india" />
      </Helmet>

      {/* <center><h3 style={{color: "red"}}>sorry, site is under technical modifications, services will be back as soon as possible</h3></center> */}
      {/* <TopHeader /> */}
      <Header homePg={true} />
      {/* <NavBar /> */}
      <div>
        <div className="main-content">
          <CarouselSlider />
          <div className="info-block"
          >
            <div className="about-block" id="about-us">
              <Aboutus />
            </div>
            <div className="announce-block" id="news">
              {/* <h1 className="section-headers">LATEST NEWS </h1> */}
              <Announcements />
            </div>
          </div>
          <div id="universities">
            <Unversities />
          </div>

          {/* <GoogleForms /> */}

          <ApplicationRequirements />

          <ApplicationGetWays />

          <Testimonials />


          <div id="contactus" className="contactus">
            <ServicesAndContacts />
          </div>

          <Footer />
        </div>
      </div>
    </>
  );
}

export default Home;
